import { referralApi } from './referralApi';
import { IGetReferrerResponse, ILinkReferralAccount } from './referralTypes';

async function linkReferralAccount(referralLink: string): Promise<ILinkReferralAccount> {
  const referralAPI = await referralApi.linkReferralAccount(referralLink);

  return referralAPI;
}

async function getReferrer(): Promise<IGetReferrerResponse> {
  const response = await referralApi.getReferrer();

  return response;
}

export const referralService = {
  linkReferralAccount,
  getReferrer,
};
